import { ApiStatuses } from '../../../../global/models/api-model';
import { ArcRoutes } from '../../constants/routes';

export function GetRemoveResponseRedirectUrl() {
	return `${ArcRoutes.ArcRoot}${ArcRoutes.InstitutionRoot}${ArcRoutes.InstitutionRemoveRequestSubmitted}`;
}

export function GetAddResponseRedirectUrl() {
	return `${ArcRoutes.ArcRoot}${ArcRoutes.InstitutionRoot}${ArcRoutes.InstitutionAddRequestSubmitted}`;
}

export function GetResponseStatus(response) {
	return response?.alreadysubmitted ? ApiStatuses.NoChange : ApiStatuses.Success;
}